@if (footerDetail) {
  <footer class="DatagridFooter__Wrapper">
    <div class="DatagridFooter" data-test-id="datagridFooter">
      @for (column of config?.columns; track column; let i = $index) {
        <div
          class="DatagridFooter__cell"
          [ngClass]="{
            'DatagridFooter__cell--alignLeft': column.isLeftAligned,
            'DatagridFooter__cell--alignRight': column.isRightAligned,
            'DatagridFooter__cell--alignCenter':
              column.isCenterAligned ||
              (!column.isLeftAligned && !column.isRightAligned),
          }"
          [ngStyle]="{
            width: getColumnWidth(column),
            'min-width': getColumnWidth(column),
            'max-width': getColumnWidth(column),
          }"
          [attr.data-test-id]="'datagridFooterColumn-' + i"
          role="cell"
        >
          <p
            tabindex="0"
            [innerHTML]="getFormattedValue(footerDetail, column) || '—'"
          ></p>
        </div>
      }
    </div>
  </footer>
}
